import SubscriptionsServiceClient from "@seneca/subscriptions-service-client";

import { Dispatch, GetState } from "common/types";

import {
  fetchAllSubscriptionProductsActionFactory,
  receiveSubscriptionProducts,
  subscriptionProductsNeedFetching
} from "../state";

// For testing purposes we're able to inject a mock client
export const makeFetchSubscriptionProducts = (
  getClient: () => SubscriptionsServiceClient
) => {
  return fetchAllSubscriptionProductsActionFactory({
    requestFunction: () => getClient().fetchPromotedSubscriptionProducts(),
    storeAction: receiveSubscriptionProducts
  });
};

export const makeFetchSubscriptionProductsIfNotFetched = (
  getClient: () => SubscriptionsServiceClient
) => {
  const fetchSubscriptionProducts = makeFetchSubscriptionProducts(getClient);

  return () => async (dispatch: Dispatch, getState: GetState) => {
    if (subscriptionProductsNeedFetching(getState())) {
      // @ts-ignore
      dispatch(fetchSubscriptionProducts());
    }
  };
};
